import React, { useState, useEffect, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import CONSTANTS from "../util/constants";
import { useDispatch, useSelector } from "react-redux";
import ModalComponent from "./ModalComponent";
import DataTable from "react-data-table-component";
import { DataInput } from "./DataComponent";
import * as XLSX from "xlsx";
import Encrypt from "./../util/encrypt";
import { exportFile } from "../util/exportFile";
import DeleteModalComponent from "./DeleteModalCompo";

const LotsComp = () => {
  const [cellData, setCellClickData] = useState(null);
  const [isShowModalCancel, setIsShowModalCancel] = useState(false);

  const [modalShow, isModalShow] = useState(false);

  const [rowData, setRowData] = useState([]);

  const rowDataLot = useSelector((state) => state.lots.getLotDivisionData);

  const rowDataSpaceTemp = useSelector((state) => state.lots.getSpaceByLotData);

  const rowDataSpaceLogTemp = useSelector(
    (state) => state.lots.getSpaceLogData
  );

  const [rowDataSpace, setRowDataSpace] = useState([]);

  const [isShowLog, setIsShowLogClicked] = useState(false);

  const [dataForLogs, setDataForLogs] = useState({});

  const [currentRow, setCurrentRow] = useState(null);

  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );

  const isSpaceForLotAPICalled = useSelector(
    (state) => state.lots.isLotSpaceAPICalled
  );

  const [loginResponse, setLoginResponse] = useState(null);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    dispatch({
      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
        .GET_LOTS_DIVISION_MANAGEMENT_API_CALL,
    });
  }, []);

  useEffect(() => {
    setColumnDef([
      {
        name: "Division",
        filter: true,
        sortable: true,
        resizable: true,
        flex: 1,
        selector: (params) => params?.divisionName,
      },
      {
        name: "Yard Name",
        filter: true,
        sortable: true,
        resizable: true,
        flex: 1,
        selector: (params) => params?.lotName,
      },
      {
        name:
          loginResponse &&
          loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority
            ? "Actions"
            : "",
        filter: true,
        resizable: true,
        flex: 2,
        ignoreRowClick: true,
        allowOverflow: true,
        cell: (row) =>
          loginResponse &&
          ((loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
            loginResponse?.user?.userRoles[0]?.priority) ||
            (loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
              loginResponse?.user?.userRoles[0]?.priority)) ? (
            <>
              <div
                onClick={() => {
                  setCellClickData(row);
                  setIsShowModalCancel(true);
                }}
              >
                <img
                  style={{ marginLeft: 20 }}
                  src={require("./../assets/Dashboard/cancel.png")}
                />
              </div>
              <div
                onClick={() => {
                  setCellClickData(row);
                  showModal(true);
                }}
              >
                <img
                  style={{ marginLeft: 20 }}
                  src={require("./../assets/Dashboard/actions.png")}
                />
              </div>
            </>
          ) : null,
      },
    ]);
  }, [loginResponse]);

  const showModalCancel = (isShow) => {
    setIsShowModalCancel(isShow);
  };

  useEffect(() => {
    if (
      rowDataLot &&
      rowDataLot?.callBackStatus != "Failed" &&
      rowDataLot?.length > 0
    ) {
      let filterData = rowDataLot?.filter((item) => {
        return (
          divisionSelectedTemp?.value == item.division_id && item.is_active
        );
      });
      console.log(" filtering data", filterData);
      setRowData(filterData);
    }
  }, [rowDataLot]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true,
  }));

  const [columnDefsSpace] = useState([
    {
      name: "Number",
      filter: true,
      sortable: true,
      resizable: true,
      flex: 1,
      selector: (params) => params?.btId,
    },
    {
      name: "Current Ouccpacy",
      filter: true,
      sortable: true,
      resizable: true,
      flex: 1,
      selector: (params) => {
        let currentOccupancy =
          params?.trailerBtId != null && params?.trailerBtId
            ? params?.trailerBtId
            : "EMPTY";
        return currentOccupancy;
      },
    },
    {
      name: "Logs",
      filter: true,
      resizable: true,
      flex: 1,
      ignoreRowClick: true,
      allowOverflow: true,
      cell: (row) => (
        <div
          onClick={() => {
            setCellClickData(row);
            setIsShowLogClicked(true);
            dispatch({
              type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                .GET_SPACELOGS_MANAGEMENT_API_CALL,
              payload: { value: row },
            });
          }}
        >
          <p
            style={{
              width: "100%",
              height: "70%",
              backgroundColor: "rgb(0, 42, 74)",
              color: "white",
              borderRadius: 5,
              margin: 0,
              padding: "5px 10px",
              fontSize: 11,
            }}
          >
            {" "}
            <strong>{"Show Log"}</strong>{" "}
          </p>
        </div>
      ),
    },
  ]);

  const formatAMPM = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes;
    return strTime;
  };

  const [columnDefsLog] = useState([
    {
      headerName: "Date",
      field: "createdAt",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let myDate =
          params?.data?.createdAt != null && params?.data?.createdAt != ""
            ? new Date(params?.data?.createdAt)
            : "";
        let dateTimeFormat =
          myDate.getMonth() +
          1 +
          "/" +
          myDate.getDate() +
          "/" +
          myDate.getFullYear() +
          " " +
          formatAMPM(myDate);
        return dateTimeFormat;
      },
    },
    {
      headerName: "Type",
      field: "logType",
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Previous Occupant",
      width: "80px",
      field: "preOccupancy",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let preOccupancy =
          params?.data?.prevOccupancy != null &&
          params?.data?.prevOccupancy?.btId
            ? params?.data?.prevOccupancy?.btId
            : "EMPTY";
        return preOccupancy;
      },
    },
    {
      headerName: "User",
      field: "user",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let userName =
          params?.data?.user != null
            ? (params?.data?.user?.firstName
                ? params.data.user.firstName
                : "") +
              "_" +
              (params?.data?.user?.lastName ? params.data.user.lastName : "")
            : "---";
        return userName;
      },
    },
    {
      headerName: "Current Occupancy",
      field: "currentOccupancy",
      filter: true,
      resizable: true,
      flex: 1,
      valueGetter: (params) => {
        let currentOccupancy =
          params?.data?.currOccupancy != null &&
          params?.data?.currOccupancy?.btId
            ? params?.data?.currOccupancy?.btId
            : "EMPTY";
        return currentOccupancy;
      },
    },
  ]);

  const tableComponentShow = (paramas) => {
    return (
      <div
        className="col-12 col-lg-12 col-md-12 col-sm-12 ag-theme-alpine"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        {loginResponse &&
        ((loginResponse?.user?.userRoles[0]?.user_role_name ==
          CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
          loginResponse?.user?.userRoles[0]?.priority) ||
          (loginResponse?.user?.userRoles[0]?.user_role_name ==
            CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
            loginResponse?.user?.userRoles[0]?.priority)) ? (
          <p
            style={{
              cursor: "pointer",
              width: "10%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              backgroundColor: "lightBlue",
              borderRadius: 8,
              marginLeft: 12,
              padding: 4,
            }}
            onClick={() => {
              let exportData = [];

              for (let i = 0; i < rowDataSpace?.length; i++) {
                let data = {
                  btId: rowDataSpace[i]?.btId,
                  trailerBtId: rowDataSpace[i]?.trailerBtId || "EMPTY",
                };
                exportData[i] = data;
              }
              let headerData = ["Number", "Current Occupancy"];
              exportFile("SpaceReport", exportData, headerData);
            }}
          >
            EXPORT
          </p>
        ) : null}
        <DataTable
          pagination
          columns={columnDefsSpace}
          data={rowDataSpace}
          allowOverflow={true}
          onRowClicked={(data) => {
            setDataForLogs(paramas);
          }}
          responsive={true}
        />
      </div>
    );
  };

  const cellImageRender = (params) => {
    if (params?.data?.space?.length <= 0 && !isSpaceForLotAPICalled) {
      dispatch({
        type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
          .GET_SPACES_BY_LOTID_MANAGEMENT_API_CALL,
        payload: { value: dataForLogs },
      });
    } else {
      if (dataForLogs == null) {
        setDataForLogs(params?.data);
      }
      if (rowDataSpaceTemp) {
        setRowDataSpace(rowDataSpaceTemp);
        return tableComponentShow(params?.data);
      }
    }
  };

  const [columnDefs, setColumnDef] = useState([]);

  const dispatch = useDispatch();

  const showModal = (isShow) => {
    isModalShow(isShow);
  };

  const importLOt = (file) => {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      /* Parse data */

      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 0 });
      /* Update state */
      if (data && data.length > 0) {
        let payload = [];
        for (let i = 0; i < data.length; i++) {
          payload.push({
            lotName: data[i].lotName,
            division_id: data[i].division_id,
          });
        }
        dispatch({
          type: CONSTANTS.CONSTANTS_WORKSHEET_MANAGEMENT.LOTS_BULK_API_CALL,
          payload: { value: payload },
        });
      } else {
        alert("Failed to load data");
      }
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  return (
    <div className="row">
      {modalShow ? (
        <ModalComponent
          title={cellData != null ? "Edit Yard" : "Add Yard"}
          show={showModal}
          handleClose={showModal}
          lotManagement={true}
          isShow={showModal}
          rowDataLot={cellData}
          setValue={(value) => {
            isModalShow(false);

            if (cellData != null) {
              setCellClickData(null);
              dispatch({
                type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                  .EDIT_LOTS_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            } else {
              dispatch({
                type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                  .ADD_LOTS_MANAGEMENT_API_CALL,
                payload: { value: value },
              });
            }
          }}
        />
      ) : null}

      {isShowModalCancel ? (
        <DeleteModalComponent
          title={"Delete Yard?"}
          show={showModalCancel}
          handleClose={false}
          isShow={showModalCancel}
          LotsManagement={true}
          data={cellData}
          setValue={(value) => {
            console.log("value122", value);
            setIsShowModalCancel(false);
            setCellClickData(null);
            dispatch({
              type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                .EDIT_LOTS_MANAGEMENT_API_CALL,
              payload: { value: value },
            });
          }}
        />
      ) : null}

      {isShowLog ? (
        <div
          className="col-12 col-lg-12 col-md-12 col-sm-12 ag-theme-alpine"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "80vh",
            width: "80vw",
            justifyContent: "space-between",
          }}
        >
          <div
            onClick={() => {
              setCellClickData([]);
              setIsShowLogClicked(false);
            }}
            className="row wrapper col-8 col-md-4 col-sm-6 col-lg-3"
            style={{
              marginLeft: 12,
              marginBottom: 5,
              height: "4vh",
              width: "auto",
              backgroundColor: "darkGray",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <label
              style={{ fontSize: "1.1em", color: "white", textAlign: "center" }}
            >
              {"Show All Yards"}
            </label>
          </div>

          <div
            className=" col-12 collg-12 col-md-12 col-sm-12 "
            style={{
              height: "40vh",
            }}
          >
            <div
              className="col-12 collg-12 col-md-12 col-sm-12 "
              style={{
                display: "flex",
                height: "6vh",
                backgroundColor: "#0dcaf0",
                border: "2px solid rgba(0, 0, 0, 0.1)",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label style={{ fontSize: 18, color: "white" }}>
                {dataForLogs?.divisionName + "_" + dataForLogs?.lotName}
              </label>
            </div>

            <div
              className="col-12 collg-12 col-md-12 col-sm-12 "
              style={{
                display: "flex",
                flexDirection: "column",
                height: "24vh",
                backgroundColor: "white",
                border: "2px solid rgba(0, 0, 0, 0.1)",
              }}
            >
              <div
                className="row col-12 collg-12 col-md-12 col-sm-12 "
                style={{
                  display: "flex",
                  height: "12vh",
                  backgroundColor: "white",
                  borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Division : \n"}
                    {dataForLogs?.divisionName
                      ? dataForLogs.divisionName
                      : "--"}
                  </label>
                </div>
                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Yard : \n"}
                    {dataForLogs?.lotName ? dataForLogs.lotName : "--"}
                  </label>
                </div>
              </div>

              <div
                className="row col-12 collg-12 col-md-12 col-sm-12"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "12vh",
                  backgroundColor: "white",
                  borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                }}
              >
                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Number : \n"}
                    {cellData?.btId ? cellData.btId : "--"}
                  </label>
                </div>
                <div
                  className=" col-12 col-lg-6 col-md-6 col-sm-12 "
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  <label style={{ fontSize: 14, color: "black" }}>
                    {"Current Occupant : \n"}
                    {cellData?.trailerBtId ? cellData.trailerBtId : "EMPTY"}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-md-12 col-sm-12 ag-theme-alpine"
            style={{
              height: "40vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            <AgGridReact
              suppressColumnVirtualisation={true}
              defaultColDef={defaultColDef}
              animateRows={true}
              rowData={rowDataSpaceLogTemp}
              rowSelection={"multiple"}
              rowGroupPanelShow={"always"}
              pivotPanelShow={"always"}
              columnDefs={columnDefsLog}
            ></AgGridReact>
          </div>
        </div>
      ) : (
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <div
            onClick={() => {
              setCellClickData(null);
            }}
            className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              margin: "2px 0 2px 0px",
            }}
          >
            {loginResponse &&
            loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
            loginResponse?.user?.userRoles[0]?.priority ? (
              <DataInput handleFile={importLOt} />
            ) : null}
            <div className="ms-md-auto pe-md-3 d-flex align-items-center">
              <div className="input-group">
                <span className="input-group-text text-body">
                  <i className="fas fa-search" aria-hidden="false"></i>
                </span>
                <input
                  aria-label="Search"
                  autoComplete={"false"}
                  data-html={true}
                  data-tip="&amp;#8226; Use atleast 12 characters.<br />
                                    &amp;#8226; Include both lowercase and uppercase characters.<br />
                                    &amp;#8226; Include atleast one number or symbol.<br />
                                    &amp;#8226; Password should not be based on any personal information such as user id, family name, pet, birthday, friends, co-workers, addresses, phone numbers, etc."
                  aria-describedby="basic-addon2"
                  type="text"
                  className="form-control"
                  placeholder="Type here..."
                  onChange={(value) => {
                    let filterData = [];
                    if (value.target?.value == "") {
                      filterData = rowDataLot;
                      setRowData(filterData);
                    } else {
                      filterData = rowDataLot?.filter((item) => {
                        return (
                          item.divisionName
                            ?.toLowerCase()
                            ?.includes(value.target.value.toLowerCase()) ||
                          item.lotName
                            ?.toLowerCase()
                            ?.includes(value.target.value.toLowerCase())
                        );
                      });
                      setRowData(filterData);
                    }
                  }}
                ></input>
              </div>
            </div>

            {loginResponse &&
            ((loginResponse?.user?.userRoles[0]?.user_role_name ==
              CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
              loginResponse?.user?.userRoles[0]?.priority) ||
              (loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                loginResponse?.user?.userRoles[0]?.priority)) ? (
              <img
                onClick={() => {
                  isModalShow(true);
                  setCellClickData(null);
                }}
                src={require("./../assets/Dashboard/plus.png")}
              ></img>
            ) : null}

            {isShowLog ||
            (loginResponse &&
              ((loginResponse?.user?.userRoles[0]?.user_role_name ==
                CONSTANTS.CONSTANTS_USER_ROLES.ADMIN &&
                loginResponse?.user?.userRoles[0]?.priority) ||
                (loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN &&
                  loginResponse?.user?.userRoles[0]?.priority))) ? (
              <p
                style={{
                  cursor: "pointer",
                  fontSize: 14,
                  textAlign: "center",
                  backgroundColor: "lightBlue",
                  borderRadius: 8,
                  marginLeft: 2,
                  padding: 6,
                  margin: 0,
                }}
                onClick={() => {
                  let exportData = [];

                  for (let i = 0; i < rowDataLot?.length; i++) {
                    let data = {
                      Division: rowDataLot[i]?.divisionName,
                      "Yard Name": rowDataLot[i]?.lotName,
                    };
                    exportData[i] = data;
                  }
                  exportFile("LotReport", exportData, [
                    "Division",
                    "Yard Name",
                  ]);
                }}
              >
                {"EXPORT"}
              </p>
            ) : null}
          </div>

          <div
            className="col-md-12 col-sm-12 row-10 ag-theme-alpine"
            style={{
              height: "80vh",
              width: "80vw",
              margin: "auto",
            }}
          >
            {rowData?.length > 0 ? (
              <DataTable
                pagination
                columns={columnDefs}
                data={rowData}
                expandableRows
                expandableRowExpanded={(row) => row == currentRow}
                expandableRowsComponent={cellImageRender}
                onRowClicked={(row) => {
                  setCurrentRow(null);
                  setCurrentRow(row);
                  setDataForLogs(row);
                  dispatch({
                    type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                      .GET_LOT_SPACE_API_CALLED,
                    payload: { value: false },
                  });
                }}
                onRowExpandToggled={(bool, row) => {
                  if (bool) {
                    setCurrentRow(null);
                    setDataForLogs(row);
                    setCurrentRow(row);
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOTS_MANAGEMENT
                        .GET_LOT_SPACE_API_CALLED,
                      payload: { value: false },
                    });
                  }
                }}
                responsive={true}
              />
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};
export default LotsComp;
